import React, { useEffect } from "react";
import Loader from "../components/Loader";
import { useTranslation } from "react-i18next";
import Seo from "../components/Seo";
import Newsletter from "../components/Newsletter";
import ContactForm from "../components/ContactForm";
import Breadcrumbs from "../components/Breadcrumbs";
import { getTranslatedPath } from "../utils/languageUtils";

export default function Contact({ setHeader }) {
  const { t, i18n } = useTranslation();
  const currentPaths = getTranslatedPath(i18n.language);
  const alternateLinks = [
    { hrefLang: "en", href: getTranslatedPath("en")["contact"] },
    { hrefLang: "sr", href: getTranslatedPath("sr")["contact"] },
  ];
  const breadcrumbs = [
    { name: t("header.home.menuTitle"), url: `/${i18n.language}` },
    { name: t("header.contact.pageTitle"), url: currentPaths["contact"] },
  ];

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 1) {
        setHeader(true);
      } else {
        setHeader(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [setHeader]);

  return (
    <>
      <Seo
        title={t("header.contact.pageTitle")}
        description={t("header.contact.metaDescription")}
        path={currentPaths["contact"]}
        alternateLinks={alternateLinks}
        breadcrumbs={breadcrumbs}
      />
      <Loader />
      {/* <!-- Main content Start --> */}
      <div className="main-content">
        {/* <!-- Breadcrumbs Start --> */}
        <div className="rs-breadcrumbs img3">
          <div className="container">
            <div className="breadcrumbs-inner">
              <h1 className="page-title">
                {t("home.contact.contact")}
                {/*<span className="watermark">{home.contact.contact}</span>*/}
              </h1>
            </div>
          </div>
        </div>
        <Breadcrumbs bg="light" />
        {/* <!-- Breadcrumbs End --> */}

        {/* <!-- Contact Section Start --> */}
        <div className="rs-contact contact-page gray-bg4 home-style1 home-style3 contact-home-style4 height-ctrl pt-130 md-pb-50 md-pt-40">
          <div className="container">
            <div className="sec-title text-center mb-60 md-mb-40">
              <h2 className="title title2 title3 text-middle">
                {t("home.contact.title")}
              </h2>
            </div>
            {/* <!-- Contact Section Start --> */}
            <div className="rs-contact">
              <div className="row y-middle">
                <div className="col-lg-6 pr-40 md-pr-15 md-mb-50">
                  <div className="contact-map">
                    <iframe
                      title="Location"
                      src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d11323.815743977078!2d20.4463451!3d44.8021274!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x475a71158f3b75d9%3A0x3cdfdea1cf3307be!2sDUR%C5%8C%20%7C%20Niche%20perfumery!5e0!3m2!1sen!2srs!4v1681389080409!5m2!1sen!2srs"
                    ></iframe>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="contact-wrap">
                    <div id="form-messages"></div>
                    <ContactForm />
                  </div>
                </div>
              </div>
            </div>
            {/* <!-- Contact Section End --> */}
          </div>
        </div>
        {/* <!-- Contact Section End -->  */}
        {/* <!-- Map Section Start --> */}
        <div
          id="map"
          className="rs-contact contact-page gray-bg4 home-style1 home-style3 contact-home-style4 height-ctrl pt-130 md-pb-50 md-pt-40"
        >
          <div className="container">
            <div className="sec-title text-center mb-60 md-mb-40">
              <h2 className="title title2 title3 text-middle">
                {t("home.contact.mapTitle")}
              </h2>
            </div>
            {/* <!-- Contact Section Start --> */}
            <div className="rs-contact">
              <div className="row y-middle">
                <div className="col-lg-12 pr-40 md-pr-15 md-mb-50">
                  <div className="contact-map">
                    <img
                      src="/assets/images/contact/map/duro_galerija_map.jpg"
                      alt="DURŌ map"
                      title="DURŌ map"
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* <!-- Contact Section End --> */}
          </div>
        </div>
        {/* <!-- Map Section End -->  */}

        {/* <!-- Newsletter section start --> */}
        <div className="rs-newsletter gray-bg4 style1 pt-90 md-pt-60 mb--65">
          <Newsletter />
        </div>
        {/* <!-- Newsletter section end --> */}
      </div>
      {/* <!-- Main content End --> */}
    </>
  );
}
